"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenT = exports.isOpen = exports.isPassibleT = exports.isPassible = exports.placeMonstersInRooms = exports.spawnRandomMonster = exports.spawnRandomItemFromList = exports.spawnRandomScroll = exports.spawnRandomPotion = exports.spawnRandomItem = exports.findOpenRoomSpot = exports.placeItemsInRooms = exports.resetVisionToWasSeen = exports.calculatePlayerVision = exports.createLightPasses = exports.placeStairsInLastRoom = exports.placePlayerInFirstRoom = exports.drawAll = exports.getCurrentMap = exports.hasMap = exports.create = exports.setTile = exports.setVisibility = exports.killAll = exports.kill = exports.destroyImages = exports.inRange = exports.getTile = exports.EVision = exports.ETile = void 0;
var ROT = __importStar(require("rot-js"));
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueRunMode_sidecar_1 = require("../input/rogueRunMode-sidecar");
var rogueDungeonFeatures_sidecar_1 = require("../items/rogueDungeonFeatures-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueItemsData_sidecar_1 = require("../items/rogueItemsData-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueMonstersData_sidecar_1 = require("../monsters/rogueMonstersData-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var rogueScreenColor_sidecar_1 = require("../ui/rogueScreenColor-sidecar");
var ETile;
(function (ETile) {
    ETile[ETile["Error"] = -1] = "Error";
    ETile[ETile["None"] = 0] = "None";
    ETile[ETile["Floor"] = 1] = "Floor";
    ETile[ETile["Wall"] = 2] = "Wall";
    ETile[ETile["Corridor"] = 3] = "Corridor";
    ETile[ETile["Door"] = 4] = "Door";
    ETile[ETile["DoorOpen"] = 5] = "DoorOpen";
})(ETile = exports.ETile || (exports.ETile = {}));
var EVision;
(function (EVision) {
    EVision[EVision["None"] = 0] = "None";
    EVision[EVision["WasSeen"] = 1] = "WasSeen";
    EVision[EVision["Seen"] = 2] = "Seen";
})(EVision = exports.EVision || (exports.EVision = {}));
var _objs = [];
var _currentMap = null;
var getTile = function (map, x, y) {
    if (!(0, exports.inRange)(map, x, y)) {
        return null;
    }
    return map.items[x + y * map.w];
};
exports.getTile = getTile;
var inRange = function (map, x, y) {
    return x >= 0 && x < map.w && y >= 0 && y < map.h;
};
exports.inRange = inRange;
// Hide this current level
var destroyImages = function (map) {
    map.items.forEach(function (c) {
        if (c.image) {
            c.image.destroy();
            c.image = null;
        }
        if (c.imageFogOfWar) {
            c.imageFogOfWar.destroy();
            c.imageFogOfWar = null;
        }
    });
};
exports.destroyImages = destroyImages;
var kill = function (c) {
    c.isDead = true;
    (0, exports.destroyImages)(c);
};
exports.kill = kill;
var killAll = function () {
    _objs.forEach(function (c) {
        (0, exports.kill)(c);
    });
    cleanup();
};
exports.killAll = killAll;
var cleanup = function () {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(_objs, function (c) {
        (0, exports.destroyImages)(c);
    });
};
var setVisibility = function (map, x, y, eVision) {
    if (!(0, exports.inRange)(map, x, y)) {
        console.log('setVisibility', 'out of range', x, y, eVision);
        return;
    }
    var item = map.items[x + y * map.w];
    if (item) {
        item.eVision = eVision;
        if (eVision === EVision.None) {
            if (item.imageFogOfWar) {
                item.imageFogOfWar.visible = false;
            }
            if (item.image) {
                item.image.visible = false;
            }
        }
        else if (eVision === EVision.Seen) {
            if (item.imageFogOfWar) {
                item.imageFogOfWar.visible = false;
            }
            if (item.image) {
                item.image.visible = true;
            }
        }
        else {
            // Was seen
            if (!item.imageFogOfWar) {
                var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().fogOfWar, sprites_sidecar_1.sprites.rogue33[0]);
                image.scale = rogueDef_sidecar_1.rogueDef.scale;
                item.imageFogOfWar = image;
            }
            item.imageFogOfWar.visible = true;
            var sprite = sprites_sidecar_1.sprites.rogue43;
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(item.imageFogOfWar, sprite[0]);
            if (item.image) {
                item.image.visible = true;
            }
        }
    }
};
exports.setVisibility = setVisibility;
var setTile = function (map, x, y, eTile) {
    if (!(0, exports.inRange)(map, x, y)) {
        console.log('setTile', 'out of range', x, y, eTile);
        return;
    }
    var item = map.items[x + y * map.w];
    if (item) {
        item.eTile = eTile;
        var sprite = sprites_sidecar_1.sprites.rogue33;
        if (eTile === ETile.Floor) {
            sprite = sprites_sidecar_1.sprites.rogue20;
        }
        if (eTile === ETile.Wall) {
            sprite = sprites_sidecar_1.sprites.rogue21;
        }
        if (eTile === ETile.Door) {
            sprite = sprites_sidecar_1.sprites.rogue11;
        }
        if (eTile === ETile.DoorOpen) {
            sprite = sprites_sidecar_1.sprites.rogue41;
        }
        if (eTile === ETile.Corridor) {
            sprite = sprites_sidecar_1.sprites.rogue32;
        }
        item.frames = sprite;
        if (!item.image) {
            var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().map, sprites_sidecar_1.sprites.rogue33[0]);
            image.scale = rogueDef_sidecar_1.rogueDef.scale;
            item.image = image;
        }
        spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(item.image, item.frames[0]);
        // Reset visibility
        (0, exports.setVisibility)(map, x, y, item.eVision);
    }
};
exports.setTile = setTile;
var create = function () {
    var w = rogueDef_sidecar_1.rogueDef.screenWidth;
    var h = rogueDef_sidecar_1.rogueDef.screenHeight - 3;
    var map = new ROT.Map.Digger(w, h, {});
    var c = {
        w: w,
        h: h,
        items: [],
        map: map,
        isGenerated: false,
        dungeonLevel: _objs.length + 1,
        isDead: false,
    };
    _objs.push(c);
    _currentMap = c;
    map.create(function (x, y, contents) {
        // console.log('map', x, y, contents)
    });
    // Map finished?
    for (var j = 0; j < h; j++) {
        for (var i = 0; i < w; i++) {
            // let image = spritesUtil.createImage(
            //   rogueLayers.getLayers().map,
            //   sprites.rogue33[0],
            // )
            // image.scale = rogueDef.scale
            c.items.push({
                x: i,
                y: j,
                frames: sprites_sidecar_1.sprites.rogue33,
                eTile: ETile.None,
                image: null,
                imageFogOfWar: null,
                eVision: EVision.None,
            });
        }
    }
    var drawDoor = function (x, y) {
        // display.draw(x, y, '+', '', 'red')
        (0, exports.setTile)(c, x, y, ETile.Door);
    };
    var rooms = map.getRooms();
    for (var roomIdx = 0; roomIdx < rooms.length; roomIdx++) {
        var room = rooms[roomIdx];
        var l = room.getLeft();
        var r = room.getRight();
        var t = room.getTop();
        var b = room.getBottom();
        for (var i = l; i <= r; i++) {
            for (var j = t; j <= b; j++) {
                // display.draw(i, j, '', '', 'blue')
                (0, exports.setTile)(c, i, j, ETile.Floor);
            }
        }
        for (var i = l - 1; i <= r + 1; i++) {
            (0, exports.setTile)(c, i, t - 1, ETile.Wall);
            (0, exports.setTile)(c, i, b + 1, ETile.Wall);
            // display.draw(i, t - 1, '-', '', 'yellow')
            // display.draw(i, b + 1, '-', '', 'yellow')
        }
        for (var j = t - 1; j <= b + 1; j++) {
            (0, exports.setTile)(c, l - 1, j, ETile.Wall);
            (0, exports.setTile)(c, r + 1, j, ETile.Wall);
            // display.draw(l - 1, j, '|', '', 'yellow')
            // display.draw(r + 1, j, '|', '', 'yellow')
        }
        // display.draw(l - 1, t - 1, 'A', '', 'yellow')
        // display.draw(r + 1, t - 1, 'B', '', 'yellow')
        // display.draw(r + 1, b + 1, 'C', '', 'yellow')
        // display.draw(l - 1, b + 1, 'D', '', 'yellow')
        room.getDoors(drawDoor);
    }
    var corridors = map.getCorridors();
    for (var corridorIdx = 0; corridorIdx < corridors.length; corridorIdx++) {
        var corridor = corridors[corridorIdx];
        var sx = corridor._startX;
        var sy = corridor._startY;
        var ex = corridor._endX;
        var ey = corridor._endY;
        if (sx > ex) {
            var swap = ex;
            ex = sx;
            sx = swap;
        }
        if (sy > ey) {
            var swap = ey;
            ey = sy;
            sy = swap;
        }
        // console.log('corridor', corridorIdx, c, sx, sy)
        for (var i = sx; i <= ex; i++) {
            for (var j = sy; j <= ey; j++) {
                (0, exports.setTile)(c, i, j, ETile.Corridor);
                // console.log('draw', i, j)
                // display.draw(i, j, 'x', '', 'green')
            }
        }
    }
    c.isGenerated = true;
    return c;
};
exports.create = create;
var hasMap = function () {
    return _objs.length > 0;
};
exports.hasMap = hasMap;
var getCurrentMap = function () {
    if (!_currentMap) {
        return (0, exports.create)();
    }
    return _currentMap;
};
exports.getCurrentMap = getCurrentMap;
var drawAll = function () {
    // let game = game2.getGame()
    var map = (0, exports.getCurrentMap)();
    if (!map) {
        return;
    }
    map.items.forEach(function (c) {
        if (c.image) {
            c.image.x = c.x * rogueDef_sidecar_1.rogueDef.sizeX;
            c.image.y = c.y * rogueDef_sidecar_1.rogueDef.sizeY;
        }
        if (c.imageFogOfWar) {
            c.imageFogOfWar.x = c.x * rogueDef_sidecar_1.rogueDef.sizeX;
            c.imageFogOfWar.y = c.y * rogueDef_sidecar_1.rogueDef.sizeY;
        }
    });
};
exports.drawAll = drawAll;
var placePlayerInFirstRoom = function (map, player) {
    var rooms = map.map.getRooms();
    if (rooms.length === 0) {
        return;
    }
    var room = rooms[0];
    var x = room.getLeft() + 1;
    var y = room.getTop() + 1;
    rogueMonsters_sidecar_1.rogueMonsters.setPos(player, x, y);
};
exports.placePlayerInFirstRoom = placePlayerInFirstRoom;
var placeStairsInLastRoom = function (map) {
    var rooms = map.map.getRooms();
    if (rooms.length === 0) {
        return;
    }
    var room = rooms[rooms.length - 1];
    var x = room.getLeft() + 1;
    var y = room.getTop() + 1;
    var stairs = rogueDungeonFeatures_sidecar_1.rogueDungeonFeatures.create(); // EDungeonFeature.StairsDown)
    rogueDungeonFeatures_sidecar_1.rogueDungeonFeatures.setPos(stairs, x, y);
};
exports.placeStairsInLastRoom = placeStairsInLastRoom;
var createLightPasses = function (map) { return function (x, y) {
    var t = (0, exports.getTile)(map, x, y);
    if (!t) {
        return false;
    }
    if (t.eTile === ETile.DoorOpen ||
        t.eTile === ETile.Floor ||
        t.eTile === ETile.Corridor) {
        return true;
    }
    return false;
}; };
exports.createLightPasses = createLightPasses;
var calculatePlayerVision = function (map, player) {
    var lightPasses = (0, exports.createLightPasses)(map);
    var fov = new ROT.FOV.PreciseShadowcasting(lightPasses);
    rogueScreenColor_sidecar_1.rogueScreenColor.seBorderColor(rogueDef_sidecar_1.rogueDef.colors.brown);
    /* output callback */
    fov.compute(player.x, player.y, 10, function (x, y, r, visibility) {
        // var ch = r ? '' : '@'
        // var color = data[x + ',' + y] ? '#aa0' : '#660'
        // display.draw(x, y, ch, '#fff', color)
        var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
        if (m && m !== player && !m.isDead) {
            rogueRunMode_sidecar_1.rogueRunMode.cancelRunMode(); // Don't run if we see a monster
            rogueScreenColor_sidecar_1.rogueScreenColor.seBorderColor(rogueDef_sidecar_1.rogueDef.colors.red);
        }
        (0, exports.setVisibility)(map, x, y, EVision.Seen);
    });
};
exports.calculatePlayerVision = calculatePlayerVision;
var resetVisionToWasSeen = function (map) {
    for (var j = 0; j < map.h; j++) {
        for (var i = 0; i < map.w; i++) {
            var t = (0, exports.getTile)(map, i, j);
            if (t && t.eVision === EVision.Seen) {
                (0, exports.setVisibility)(map, i, j, EVision.WasSeen);
            }
        }
    }
};
exports.resetVisionToWasSeen = resetVisionToWasSeen;
var placeItemsInRooms = function (map, chance, force) {
    if (force === void 0) { force = true; }
    map.map.getRooms().forEach(function (room) {
        if (ROT.RNG.getUniform() < chance) {
            var spot = (0, exports.findOpenRoomSpot)(map, room);
            if (!spot.found) {
                console.log('warning: no open spot found in room for item');
            }
            if (spot.found || force) {
                var item = (0, exports.spawnRandomItem)();
                assert_sidecar_1.assert.notNil(item);
                rogueItems_sidecar_1.rogueItems.setPos(item, spot.x, spot.y);
            }
        }
    });
};
exports.placeItemsInRooms = placeItemsInRooms;
var findOpenRoomSpot = function (map, room) {
    var l = room.getLeft();
    var r = room.getRight();
    var t = room.getTop();
    var b = room.getBottom();
    // Random tries to find an open spot
    for (var iTry = 0; iTry < 100; iTry++) {
        var x_1 = rando_sidecar_1.rando.i(l, r);
        var y_1 = rando_sidecar_1.rando.i(t, b);
        if ((0, exports.isOpen)(map, x_1, y_1)) {
            return { x: x_1, y: y_1, found: true };
        }
    }
    // Scan for an open spot
    for (var x_2 = l; x_2 <= r; x_2++) {
        for (var y_2 = t; y_2 <= b; y_2++) {
            if ((0, exports.isOpen)(map, x_2, y_2)) {
                return { x: x_2, y: y_2, found: true };
            }
        }
    }
    // No open spots, just return a random spot
    // Put it somewhere!
    console.log('warning: no open spot found in room');
    var x = rando_sidecar_1.rando.i(l, r);
    var y = rando_sidecar_1.rando.i(t, b);
    return { x: x, y: y, found: false };
};
exports.findOpenRoomSpot = findOpenRoomSpot;
var spawnRandomItem = function () {
    var groups = {
        potion: 1,
        gold: 1,
        scroll: 1,
    };
    var group = ROT.RNG.getWeightedValue(groups) || '?';
    if (group === 'gold') {
        var gold = rogueItems_sidecar_1.rogueItems.create('gold');
        gold.amount = rando_sidecar_1.rando.i(1, 100);
        return gold;
    }
    if (group === 'potion') {
        return (0, exports.spawnRandomPotion)();
    }
    if (group === 'scroll') {
        return (0, exports.spawnRandomScroll)();
    }
    return null;
};
exports.spawnRandomItem = spawnRandomItem;
var spawnRandomPotion = function () {
    return (0, exports.spawnRandomItemFromList)(rogueItemsData_sidecar_1.rogueItemsData.dataListPotions);
};
exports.spawnRandomPotion = spawnRandomPotion;
var spawnRandomScroll = function () {
    return (0, exports.spawnRandomItemFromList)(rogueItemsData_sidecar_1.rogueItemsData.dataListScrolls);
};
exports.spawnRandomScroll = spawnRandomScroll;
var spawnRandomItemFromList = function (itemsList) {
    var items = {};
    itemsList.forEach(function (c) {
        items[c.type] = c.spawnChance;
    });
    return rogueItems_sidecar_1.rogueItems.create(ROT.RNG.getWeightedValue(items) || '?');
};
exports.spawnRandomItemFromList = spawnRandomItemFromList;
var spawnRandomMonster = function () {
    var monsters = {
    // "orc": 3,
    // "ogre": 1,
    // "rat": 5
    };
    rogueMonstersData_sidecar_1.rogueMonstersData.dataListSpawnable.forEach(function (c) {
        monsters[c.type] = c.spawnChance;
    });
    // Testing out weighted
    // for (var i = 0; i < 20; i++) {
    //   console.log(ROT.RNG.getWeightedValue(monsters))
    // }
    return rogueMonsters_sidecar_1.rogueMonsters.create(ROT.RNG.getWeightedValue(monsters) || '?');
};
exports.spawnRandomMonster = spawnRandomMonster;
var placeMonstersInRooms = function (map, chance, force) {
    if (force === void 0) { force = true; }
    map.map.getRooms().forEach(function (room) {
        if (ROT.RNG.getUniform() < chance) {
            var spot = (0, exports.findOpenRoomSpot)(map, room);
            if (!spot.found) {
                console.log('warning: no open spot found in room for monster');
            }
            if (spot.found || force) {
                var m = (0, exports.spawnRandomMonster)();
                rogueMonsters_sidecar_1.rogueMonsters.setPos(m, spot.x, spot.y);
            }
        }
    });
};
exports.placeMonstersInRooms = placeMonstersInRooms;
var isPassible = function (map, x, y) {
    // TODO: options?
    var t = (0, exports.getTile)(map, x, y);
    return (0, exports.isPassibleT)(t);
};
exports.isPassible = isPassible;
var isPassibleT = function (t) {
    if (!t) {
        return false;
    }
    if (t.eTile === ETile.Floor ||
        t.eTile === ETile.Corridor ||
        t.eTile === ETile.DoorOpen) {
        return true;
    }
    return false;
};
exports.isPassibleT = isPassibleT;
var isOpen = function (map, x, y) {
    // TODO: options?
    var t = (0, exports.getTile)(map, x, y);
    return (0, exports.isOpenT)(map, t, x, y);
};
exports.isOpen = isOpen;
var isOpenT = function (map, t, x, y) {
    if (!t) {
        return false;
    }
    if (t.eTile === ETile.Floor ||
        t.eTile === ETile.Corridor ||
        t.eTile === ETile.DoorOpen) {
        var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
        if (m) {
            return false;
        }
        var item = rogueItems_sidecar_1.rogueItems.getAt(x, y);
        if (item) {
            return false;
        }
        return true;
    }
    return false;
};
exports.isOpenT = isOpenT;
